export function isVisible(element) {
	return element && element.offsetHeight > 0 && element.offsetWidth > 0;
}
